import { useState } from 'react';
import { recommendSlideshow } from '../services/projects';
import { useLang } from '../contexts/langContext';
import { RecommendationRequest, DocxRecommendationRequest, SlideshowRecommendation } from '../types';



interface UseRecommendSlideshowReturn {
  recommendation: SlideshowRecommendation | null;
  isLoading: boolean;
  error: string | Error | null;
  getRecommendation: (request: RecommendationRequest | DocxRecommendationRequest) => Promise<void>;
  reset: () => void;
}

function useRecommendSlideshow(): UseRecommendSlideshowReturn {
  const { lang } = useLang();
  const [recommendation, setRecommendation] = useState<SlideshowRecommendation | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | Error | null>(null);

  const getRecommendation = async (request: RecommendationRequest | DocxRecommendationRequest) => {
    try {
      setIsLoading(true);
      setError(null);
      const result = await recommendSlideshow(request, lang);
      setRecommendation(result);
    } catch (err: any) {
      console.error('* Error:', err.response.data.message);
      setError(err?.response?.data?.message || (err instanceof Error ? err.message : 'Failed to get recommendation'));
      setRecommendation(null);
    } finally {
      setIsLoading(false);
    }
  };

  const reset = () => {
    setRecommendation(null);
    setError(null);
    setIsLoading(false);
  };

  return {
    recommendation,
    isLoading,
    error,
    getRecommendation,
    reset,
  };
}

export default useRecommendSlideshow; 